"use client"

import { NoticeCard } from "politicamente-informados-ds";

export interface INoticeCard {
    linePosition: string;
    title: string;
    accentColor: string;
    message: string;
    backgroundColor: string;
}

const BlockNoticeCard: React.FC<{ attrs: INoticeCard }> = ({ attrs }: { attrs: INoticeCard }) => {
    return (
        <NoticeCard {...attrs} />
    )
}

export default BlockNoticeCard;